/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Policy_Contact_Legal_Name_ValueInputs */

const es_privacy_policy_contact_legal_name_value = /** @type {(inputs: Privacy_Policy_Contact_Legal_Name_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata (empresa individual, Argentina)`)
};

const en_privacy_policy_contact_legal_name_value = /** @type {(inputs: Privacy_Policy_Contact_Legal_Name_ValueInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nexata (sole proprietorship, Argentina)`)
};

/**
* | output |
* | --- |
* | "Nexata (sole proprietorship, Argentina)" |
*
* @param {Privacy_Policy_Contact_Legal_Name_ValueInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const privacy_policy_contact_legal_name_value = /** @type {((inputs?: Privacy_Policy_Contact_Legal_Name_ValueInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Policy_Contact_Legal_Name_ValueInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_privacy_policy_contact_legal_name_value(inputs)
	return en_privacy_policy_contact_legal_name_value(inputs)
});
export { privacy_policy_contact_legal_name_value as "privacy_policy.contact.legal_name_value" }